import styled from "styled-components";

import { QUERIES, SPACING_RESPONSIVE } from "../../../utils/constants";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
`;

export const SavingDetailsWrapper = styled.div`
  margin: ${SPACING_RESPONSIVE.mobile.chartMargin}px;
  margin-bottom: 0px;

  @media ${QUERIES.tabletAndUp} {
    margin: ${SPACING_RESPONSIVE.tablet.chartMargin}px;
    margin-bottom: 0px;
  }

  @media ${QUERIES.laptopAndUp} {
    margin: ${SPACING_RESPONSIVE.desktop.chartMargin}px;
    margin-bottom: 0px;
  }
`;
